module.exports = __webpack_public_path__ + "img/spring_trip-20160416-9-768x1024.878956a6.jpg";